<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
    <div>
      @if (unifiedFxUrl) {
        <ziro-phone-fx [disabled]="!phone.id" [phoneName]="phone.name" [unifiedFxUrl]="unifiedFxUrl"></ziro-phone-fx>
      }
      <ziro-fieldset-header [legend]="'tkey;pages.details.phoneSettings.header' | translate">
        <ziro-phone-model-protocol-form
          [entity]="modelProtocolFormData"
          [fieldConfig]="modelProtocolFieldConfig"
          [phoneType]="phoneType"
          [isGeneratingPhone]="loadingSubscriptions.phoneFieldConfig || (!phone.devicePool && !!phone.protocol)"
          (modelProtocolUpdate$)="onModelProtocolFormUpdate($event)"
        ></ziro-phone-model-protocol-form>
        @if (fieldConfig && !isLoadingPhoneFields) {
          <ziro-phone-fields-form
            [cucmServerId]="cucmServerId"
            [endUserRef]="endUserRef"
            [phoneType]="phoneType"
            [fieldConfig]="fieldConfig"
            [entity]="phoneFieldsEntity"
            [isGeneratingPhone]="loadingSubscriptions.phoneFieldConfig || !phone.devicePool"
            (conflictingPhoneFound)="updateConflictingPhone($event)"
            (ziroFormsUpdate$)="onPhoneFieldsChange($event)"
            [attr.data-automation]="'phone-fields-form'"
            [isFormStateInvalid]="isFormStateInvalid"
            [isCopy]="isCopy"
            [isErrorThrown]="isErrorThrown"
          >
            @if (
              !isAutomaticPhoneButtonTemplateMode &&
              possiblePhoneButtonTemplates &&
              !isSingleButtonPhone &&
              phoneType !== PhoneType.IM_SOFTPHONE
            ) {
              <ziro-phone-button-template-form
                [entity]="phoneButtonTemplateEntity"
                [possibleOptions]="possiblePhoneButtonTemplates"
                [isErrorThrown]="false"
                (ziroFormsUpdate$)="onPhoneButtonTemplateChange($event)"
              ></ziro-phone-button-template-form>
            }
          </ziro-phone-fields-form>
        }
      </ziro-fieldset-header>
      @if (fieldConfig?.phoneServices && (fieldConfig.phoneServices.show || isExistingPhoneWithServiceSubscriptions)) {
        <ziro-phone-services-form
          [hidden]="loadingSubscriptions.phoneFieldConfig || !phone.devicePool"
          [serviceSubscriptionFieldConfig]="fieldConfig?.phoneServices"
          [entity]="phone.serviceSubscriptions"
          (ziroFormsUpdate$)="onPhoneServiceSubscriptionsChange($event)"
        ></ziro-phone-services-form>
      }
      @if (isExistingMobilityIdentity || fieldConfig?.mobilityIdentityFieldConfigJson) {
        <ziro-phone-mobility-identity
          [fieldConfig]="mobilityIdentityFieldConfig"
          [isExistingMobilityIdentity]="isExistingMobilityIdentity"
          [entity]="mobilityIdentityInitialEntity"
          (ziroFormsUpdate$)="onMobilityIdentityFormChange($event)"
          [attr.data-automation]="'phone-mobility-identity'"
        ></ziro-phone-mobility-identity>
      }
      @if (loadingSubscriptions.phoneFieldConfig) {
        <ziro-loading-block data-automation="phone-buttons-loading-block"></ziro-loading-block>
      }
      @if (phone.model && phone.protocol && phone.buttons?.length > 0 && !loadingSubscriptions.phoneFieldConfig) {
        <div data-automation="phone-buttons-container">
          @if (isSingleButtonPhone) {
            <legend>Button</legend>
          }
          @if (phoneButtonTemplateFieldConfig && phone.expansionModules && phone.phoneButtonTemplate) {
            <ziro-phone-buttons
              [userMode]="DragDropMode.HELPDESK"
              [global360View]="global360View"
              [siteId]="siteId"
              [serverId]="cucmServerId.toString()"
              [templateButtons]="phoneButtonTemplateFieldConfig.buttons"
              [isPending]="isPhoneButtonTemplateChangePending"
              [attr.data-automation]="'phone-buttons-form'"
              [fieldConfig]="fieldConfig"
              [phoneButtonTemplateConfig]="phoneButtonTemplateFieldConfig"
              [isAutomaticPhoneButtonTemplateSelectionEnabled]="isAutomaticPhoneButtonTemplateMode"
              [isEnhancedLineModeOn]="isDisplayEnhancedLineMode"
              [phoneType]="phoneType"
              (validationStateSubject)="onPhoneButtonValidationStateChange($event)"
              (copyUdpButtonClicked)="onCopyUdpButtons($event)"
            ></ziro-phone-buttons>
          }
        </div>
      }
    </div>
  </ziro-collapsible-section-card>
}
